"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const HeaderCell_1 = __importDefault(require("./HeaderCell"));
const ScrollManager_1 = __importDefault(require("../../managers/ScrollManager"));
const RenderQueue_1 = __importDefault(require("../../managers/RenderQueue"));
class HeaderRow extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.scrollListener = null;
        this.lastX = 0;
        this.headerDiv = null;
        this.tableScrolled = this.tableScrolled.bind(this);
    }
    componentDidMount() {
        this.scrollListener = ScrollManager_1.default.subscribe(this.tableScrolled);
    }
    componentWillUnmount() {
        // this check is here to make sure the scrollListener exists
        // this condition is hard to re-create in Jest, so we ignore it for coverage
        /* istanbul ignore else */
        if (this.scrollListener) {
            ScrollManager_1.default.unsubscribe(this.scrollListener);
        }
    }
    get currentX() {
        return this.lastX;
    }
    tableScrolled(scroll) {
        if (scroll.x !== this.lastX) {
            const headerOperation = {
                operation: () => {
                    // this check is here to make sure the header container exists
                    // this condition is hard to re-create in Jest, so we ignore it for coverage
                    /* istanbul ignore else */
                    if (this.headerDiv) {
                        this.headerDiv.style.transform = `translate(${-1 * scroll.x}px, 0px)`;
                    }
                },
                type: 'header'
            };
            RenderQueue_1.default.addWrite(headerOperation);
            this.lastX = scroll.x;
        }
    }
    headerCellRender(columnIndex) {
        const { columns, currentSort, sortFn } = this.props;
        const columnId = columns.visibleOrder[columnIndex];
        const column = columns.data[columnId];
        const isLast = columnIndex + 1 === columns.visibleOrder.length;
        const isActive = currentSort?.field === columnId;
        return ((0, jsx_runtime_1.jsx)(HeaderCell_1.default, { isLast: isLast, isActive: isActive, title: columnId, displayName: column.displayName, defaultDirection: column.defaultDirection || undefined, currentSort: currentSort, updateSort: sortFn }));
    }
    render() {
        const style = {
            width: this.props.contentWidth,
            height: this.props.headerHeight,
            top: 0
        };
        const cells = this.props.columnCoords.map((column, index) => {
            const cellStyle = {
                width: column.width,
                height: this.props.headerHeight
            };
            const headerCell = this.headerCellRender(index);
            return ((0, jsx_runtime_1.jsx)("div", { className: this.props.borderless
                    ? 'bah-uswds-table-header-cell--borderless'
                    : 'bah-uswds-table-header-cell', role: "columnheader", id: `${this.props.tableId}-header-${index}`, style: cellStyle, children: headerCell }, index));
        });
        return ((0, jsx_runtime_1.jsx)("div", { className: "bah-uswds-table-header", role: "presentation", style: style, ref: (div) => {
                this.headerDiv = div;
            }, children: (0, jsx_runtime_1.jsx)("div", { className: "bah-uswds-table-header-row", role: "row", children: cells }) }));
    }
}
exports.default = HeaderRow;
